import React, { FC } from 'react';
import hash from 'object-hash';
import st from './Description.module.css';

type DescriptionProps = {
  description: [string];
};

const Description: FC<DescriptionProps> = ({ description }) => {
  const formatDescription = Array.isArray(description)
    ? description
    : [description];
  return (
    <>
      {formatDescription &&
        formatDescription.map((p) => (
          <p key={hash(p)} className={st.description}>
            {p}
          </p>
        ))}

      {!formatDescription && (
        <p className={st.description}>
          Центры госуслуг — это комфортные офисы в каждом районе Москвы, где
          ежедневно быстро и удобно можно получить государственные услуги. 98%
          услуг предоставляются без привязки к месту жительства. Районные центры
          госуслуг работают по удобному графику с 08:00 до 20:00 без перерывов и
          выходных.
        </p>
      )}
    </>
  );
};

export default Description;
